import {
  PrimitiveArraySerializer6xcmeltdozbx as PrimitiveArraySerializer,
  PrimitiveArrayBuilder1tzna3i4eqw54 as PrimitiveArrayBuilder,
} from './CollectionSerializers.mjs';
import { Companion_getInstance2xebdfu7t2o0y as Companion_getInstance } from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import {
  serializer345btyh1f2y1j as serializer,
  serializer1wpgysz06u9ol as serializer_0,
  serializer3x9uckd1deom as serializer_1,
  serializerodflzzf6s3fp as serializer_2,
  serializer2lw83vwvpnyms as serializer_3,
  serializer1hu9wv9at41ww as serializer_4,
  serializer3ikrxnm8b29d6 as serializer_5,
  serializer1tw0a8bv7lkga as serializer_6,
  serializer1q7c5q67ysppr as serializer_7,
  serializer1r0h5yakm679b as serializer_8,
  serializer36584sjyg5661 as serializer_9,
  serializer3u3hsxnenk49x as serializer_10,
} from '../builtins/BuiltinSerializers.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  isCharArray21auq5hbrg68m as isCharArray,
  isDoubleArray1wyh4nyf7pjxn as isDoubleArray,
  isFloatArrayjjscnqphw92j as isFloatArray,
  isIntArrayeijsubfngq38 as isIntArray,
  isShortArraywz30zxwtqi8h as isShortArray,
  isByteArray4nnzfn1x4o3w as isByteArray,
  isBooleanArray35llghle4c6w1 as isBooleanArray,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  charArray2ujmm1qusno00 as charArray,
  booleanArray2jdug9b51huk7 as booleanArray,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/arrays.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../KSerializer.mjs';
import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  DoubleCompanionObject_instance1bwirhd8p0qhc as DoubleCompanionObject_instance,
  FloatCompanionObject_instance1gmrivpej6y77 as FloatCompanionObject_instance,
  IntCompanionObject_instance38ap4zil98hon as IntCompanionObject_instance,
  ShortCompanionObject_instancekdrujyym9g7v as ShortCompanionObject_instance,
  ByteCompanionObject_instance1i09zkznh3bs3 as ByteCompanionObject_instance,
  BooleanCompanionObject_instance1app94b8o3img as BooleanCompanionObject_instance,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/internal/primitiveCompanionObjects.mjs';
import { Companion_instance1txg8t7ewhdy9 as Companion_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Primitives.mjs';
import { isLongArray21mxwb8b0y2ii as isLongArray } from '../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import {
  Companion_getInstance2ln0tj1crqgxz as Companion_getInstance_0,
  _ULong___init__impl__c78o9k4z3cjzifecv6 as _ULong___init__impl__c78o9k,
  _ULong___get_data__impl__fggpzb2bbucljk081qt as _ULong___get_data__impl__fggpzb,
} from '../../../../kotlin-kotlin-stdlib/kotlin/ULong.mjs';
import {
  _ULongArray___get_size__impl__ju6dtr313kllzk1pm23 as _ULongArray___get_size__impl__ju6dtr,
  ULongArray3nd0d80mdwjj8 as ULongArray,
  _ULongArray___init__impl__twm1l3306egki9v2xvq as _ULongArray___init__impl__twm1l3,
  ULongArray__get_impl_pr71q91094qpdno4ge1 as ULongArray__get_impl_pr71q9,
  _ULongArray___get_storage__impl__28e64jn29edyvk0vk2 as _ULongArray___get_storage__impl__28e64j,
  _ULongArray___init__impl__twm1l311m1vqktvg80l as _ULongArray___init__impl__twm1l3_0,
  ULongArray__set_impl_z19mvh3hfs4gnea82kx as ULongArray__set_impl_z19mvh,
} from '../../../../kotlin-kotlin-stdlib/kotlin/ULongArray.mjs';
import {
  Companion_getInstance1339zuieiizg3 as Companion_getInstance_1,
  _UInt___init__impl__l7qpdl2xbmh7to8lpd7 as _UInt___init__impl__l7qpdl,
  _UInt___get_data__impl__f0vqqw2j5mttix8w0l0 as _UInt___get_data__impl__f0vqqw,
} from '../../../../kotlin-kotlin-stdlib/kotlin/UInt.mjs';
import {
  _UIntArray___get_size__impl__r6l8ci2vbtulpoxx7m6 as _UIntArray___get_size__impl__r6l8ci,
  UIntArrayrp6cv44n5v4y as UIntArray,
  _UIntArray___init__impl__ghjpc67kyasm65n9ua as _UIntArray___init__impl__ghjpc6,
  UIntArray__get_impl_gp5kzan3fixfncx7fe as UIntArray__get_impl_gp5kza,
  _UIntArray___get_storage__impl__92a0v01hz5t8os1oam0 as _UIntArray___get_storage__impl__92a0v0,
  _UIntArray___init__impl__ghjpc61eq9zlp4q89r5 as _UIntArray___init__impl__ghjpc6_0,
  UIntArray__set_impl_7f2zu213di7nm90jlnm as UIntArray__set_impl_7f2zu2,
} from '../../../../kotlin-kotlin-stdlib/kotlin/UIntArray.mjs';
import {
  Companion_getInstance3rx8u2n07bmtm as Companion_getInstance_2,
  _UShort___init__impl__jigrne3vu9egv7mch1k as _UShort___init__impl__jigrne,
  _UShort___get_data__impl__g0245313795p1x5hw5 as _UShort___get_data__impl__g0245,
} from '../../../../kotlin-kotlin-stdlib/kotlin/UShort.mjs';
import {
  _UShortArray___get_size__impl__jqto1b3rfx6oix6j8vx as _UShortArray___get_size__impl__jqto1b,
  UShortArray11avpmknxdgvv as UShortArray,
  _UShortArray___init__impl__9b26efzwhnyvfbg58m as _UShortArray___init__impl__9b26ef,
  UShortArray__get_impl_fnbhmx1exua9mtkbdj1 as UShortArray__get_impl_fnbhmx,
  _UShortArray___get_storage__impl__t2jpv53oc7c1c2s7ixe as _UShortArray___get_storage__impl__t2jpv5,
  _UShortArray___init__impl__9b26ef2fr8vrbufr3j6 as _UShortArray___init__impl__9b26ef_0,
  UShortArray__set_impl_6d8whp179ynmfb9d38q as UShortArray__set_impl_6d8whp,
} from '../../../../kotlin-kotlin-stdlib/kotlin/UShortArray.mjs';
import {
  Companion_getInstance2utgi65n0nnqj as Companion_getInstance_3,
  _UByte___init__impl__g9hnc43bwrjlqz9k9id as _UByte___init__impl__g9hnc4,
  _UByte___get_data__impl__jof9qr23gcv767stjfh as _UByte___get_data__impl__jof9qr,
} from '../../../../kotlin-kotlin-stdlib/kotlin/UByte.mjs';
import {
  _UByteArray___get_size__impl__h6pkdv2v04pt36vzsv4 as _UByteArray___get_size__impl__h6pkdv,
  UByteArray2qu4d6gwssdf9 as UByteArray,
  _UByteArray___init__impl__ip4y9n1pmtxxp603qev as _UByteArray___init__impl__ip4y9n,
  UByteArray__get_impl_t5f3hv3v1a2l4kwelbl as UByteArray__get_impl_t5f3hv,
  _UByteArray___get_storage__impl__d4kctt79a8gj8q1jsz as _UByteArray___get_storage__impl__d4kctt,
  _UByteArray___init__impl__ip4y9n1rg5c5y25iboz as _UByteArray___init__impl__ip4y9n_0,
  UByteArray__set_impl_jvcicnzooqhbuj870m as UByteArray__set_impl_jvcicn,
} from '../../../../kotlin-kotlin-stdlib/kotlin/UByteArray.mjs';
import { coerceAtLeast2bkz8m9ik7hep as coerceAtLeast } from '../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import {
  copyOf2p23ljc5f5ea3 as copyOf,
  copyOfgossjg6lh6js as copyOf_0,
  copyOfq9pcgcgbldck as copyOf_1,
  copyOf9mbsebmgnw4t as copyOf_2,
  copyOf3rutauicler23 as copyOf_3,
  copyOf39s58md6y6rn6 as copyOf_4,
  copyOfwy6h3t5vzqpl as copyOf_5,
  copyOf37mht4mx7mjgh as copyOf_6,
} from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_ArraysJs.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var CharArraySerializerClass;
function CharArraySerializer() {
  if (CharArraySerializerClass === VOID) {
    class $ extends PrimitiveArraySerializer() {
      constructor() {
        CharArraySerializer_instance = null;
        super(serializer(Companion_getInstance()));
        CharArraySerializer_instance = this;
      }
      c20(_this__u8e3s4) {
        return _this__u8e3s4.length;
      }
      r1v(_this__u8e3s4) {
        return this.c20((!(_this__u8e3s4 == null) ? isCharArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      d20(_this__u8e3s4) {
        return new (CharArrayBuilder())(_this__u8e3s4);
      }
      m1u(_this__u8e3s4) {
        return this.d20((!(_this__u8e3s4 == null) ? isCharArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      c1x() {
        return charArray(0);
      }
      e20(decoder, index, builder, checkIndex) {
        builder.h20(decoder.m1r(this.t1w_1, index));
      }
      x1u(decoder, index, builder, checkIndex) {
        return this.e20(decoder, index, builder instanceof CharArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      d1x(decoder, index, builder, checkIndex) {
        return this.e20(decoder, index, builder instanceof CharArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      i20(encoder, content, size) {
        var inductionVariable = 0;
        if (inductionVariable < size)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            encoder.s1s(this.t1w_1, i, content[i]);
          }
           while (inductionVariable < size);
      }
      e1x(encoder, content, size) {
        return this.i20(encoder, (!(content == null) ? isCharArray(content) : false) ? content : THROW_CCE(), size);
      }
    }
    initMetadataForObject($, 'CharArraySerializer', VOID, VOID, [KSerializer()]);
    CharArraySerializerClass = $;
  }
  return CharArraySerializerClass;
}
var CharArraySerializer_instance;
function CharArraySerializer_getInstance() {
  if (CharArraySerializer_instance === VOID)
    new (CharArraySerializer())();
  return CharArraySerializer_instance;
}
var DoubleArraySerializerClass;
function DoubleArraySerializer() {
  if (DoubleArraySerializerClass === VOID) {
    class $ extends PrimitiveArraySerializer() {
      constructor() {
        DoubleArraySerializer_instance = null;
        super(serializer_0(DoubleCompanionObject_instance));
        DoubleArraySerializer_instance = this;
      }
      l20(_this__u8e3s4) {
        return _this__u8e3s4.length;
      }
      r1v(_this__u8e3s4) {
        return this.l20((!(_this__u8e3s4 == null) ? isDoubleArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      m20(_this__u8e3s4) {
        return new (DoubleArrayBuilder())(_this__u8e3s4);
      }
      m1u(_this__u8e3s4) {
        return this.m20((!(_this__u8e3s4 == null) ? isDoubleArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      c1x() {
        return new Float64Array(0);
      }
      n20(decoder, index, builder, checkIndex) {
        builder.q20(decoder.l1r(this.t1w_1, index));
      }
      x1u(decoder, index, builder, checkIndex) {
        return this.n20(decoder, index, builder instanceof DoubleArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      d1x(decoder, index, builder, checkIndex) {
        return this.n20(decoder, index, builder instanceof DoubleArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      r20(encoder, content, size) {
        var inductionVariable = 0;
        if (inductionVariable < size)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            encoder.r1s(this.t1w_1, i, content[i]);
          }
           while (inductionVariable < size);
      }
      e1x(encoder, content, size) {
        return this.r20(encoder, (!(content == null) ? isDoubleArray(content) : false) ? content : THROW_CCE(), size);
      }
    }
    initMetadataForObject($, 'DoubleArraySerializer', VOID, VOID, [KSerializer()]);
    DoubleArraySerializerClass = $;
  }
  return DoubleArraySerializerClass;
}
var DoubleArraySerializer_instance;
function DoubleArraySerializer_getInstance() {
  if (DoubleArraySerializer_instance === VOID)
    new (DoubleArraySerializer())();
  return DoubleArraySerializer_instance;
}
var FloatArraySerializerClass;
function FloatArraySerializer() {
  if (FloatArraySerializerClass === VOID) {
    class $ extends PrimitiveArraySerializer() {
      constructor() {
        FloatArraySerializer_instance = null;
        super(serializer_1(FloatCompanionObject_instance));
        FloatArraySerializer_instance = this;
      }
      u20(_this__u8e3s4) {
        return _this__u8e3s4.length;
      }
      r1v(_this__u8e3s4) {
        return this.u20((!(_this__u8e3s4 == null) ? isFloatArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      v20(_this__u8e3s4) {
        return new (FloatArrayBuilder())(_this__u8e3s4);
      }
      m1u(_this__u8e3s4) {
        return this.v20((!(_this__u8e3s4 == null) ? isFloatArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      c1x() {
        return new Float32Array(0);
      }
      w20(decoder, index, builder, checkIndex) {
        builder.z20(decoder.k1r(this.t1w_1, index));
      }
      x1u(decoder, index, builder, checkIndex) {
        return this.w20(decoder, index, builder instanceof FloatArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      d1x(decoder, index, builder, checkIndex) {
        return this.w20(decoder, index, builder instanceof FloatArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      a21(encoder, content, size) {
        var inductionVariable = 0;
        if (inductionVariable < size)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            encoder.q1s(this.t1w_1, i, content[i]);
          }
           while (inductionVariable < size);
      }
      e1x(encoder, content, size) {
        return this.a21(encoder, (!(content == null) ? isFloatArray(content) : false) ? content : THROW_CCE(), size);
      }
    }
    initMetadataForObject($, 'FloatArraySerializer', VOID, VOID, [KSerializer()]);
    FloatArraySerializerClass = $;
  }
  return FloatArraySerializerClass;
}
var FloatArraySerializer_instance;
function FloatArraySerializer_getInstance() {
  if (FloatArraySerializer_instance === VOID)
    new (FloatArraySerializer())();
  return FloatArraySerializer_instance;
}
var LongArraySerializerClass;
function LongArraySerializer() {
  if (LongArraySerializerClass === VOID) {
    class $ extends PrimitiveArraySerializer() {
      constructor() {
        LongArraySerializer_instance = null;
        super(serializer_2(Companion_instance));
        LongArraySerializer_instance = this;
      }
      d21(_this__u8e3s4) {
        return _this__u8e3s4.length;
      }
      r1v(_this__u8e3s4) {
        return this.d21((!(_this__u8e3s4 == null) ? isLongArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      e21(_this__u8e3s4) {
        return new (LongArrayBuilder())(_this__u8e3s4);
      }
      m1u(_this__u8e3s4) {
        return this.e21((!(_this__u8e3s4 == null) ? isLongArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      c1x() {
        return new BigInt64Array(0);
      }
      f21(decoder, index, builder, checkIndex) {
        builder.i21(decoder.j1r(this.t1w_1, index));
      }
      x1u(decoder, index, builder, checkIndex) {
        return this.f21(decoder, index, builder instanceof LongArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      d1x(decoder, index, builder, checkIndex) {
        return this.f21(decoder, index, builder instanceof LongArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      j21(encoder, content, size) {
        var inductionVariable = 0;
        if (inductionVariable < size)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            encoder.p1s(this.t1w_1, i, content[i]);
          }
           while (inductionVariable < size);
      }
      e1x(encoder, content, size) {
        return this.j21(encoder, (!(content == null) ? isLongArray(content) : false) ? content : THROW_CCE(), size);
      }
    }
    initMetadataForObject($, 'LongArraySerializer', VOID, VOID, [KSerializer()]);
    LongArraySerializerClass = $;
  }
  return LongArraySerializerClass;
}
var LongArraySerializer_instance;
function LongArraySerializer_getInstance() {
  if (LongArraySerializer_instance === VOID)
    new (LongArraySerializer())();
  return LongArraySerializer_instance;
}
var ULongArraySerializerClass;
function ULongArraySerializer() {
  if (ULongArraySerializerClass === VOID) {
    class $ extends PrimitiveArraySerializer() {
      constructor() {
        ULongArraySerializer_instance = null;
        super(serializer_3(Companion_getInstance_0()));
        ULongArraySerializer_instance = this;
      }
      m21(_this__u8e3s4) {
        return _ULongArray___get_size__impl__ju6dtr(_this__u8e3s4);
      }
      r1v(_this__u8e3s4) {
        return this.m21(_this__u8e3s4 instanceof ULongArray() ? _this__u8e3s4.vu_1 : THROW_CCE());
      }
      n21(_this__u8e3s4) {
        return new (ULongArrayBuilder())(_this__u8e3s4);
      }
      m1u(_this__u8e3s4) {
        return this.n21(_this__u8e3s4 instanceof ULongArray() ? _this__u8e3s4.vu_1 : THROW_CCE());
      }
      o21() {
        return _ULongArray___init__impl__twm1l3(0);
      }
      c1x() {
        return new (ULongArray())(this.o21());
      }
      p21(decoder, index, builder, checkIndex) {
        // Inline function 'kotlin.toULong' call
        var this_0 = decoder.o1r(this.t1w_1, index).u1q();
        var tmp$ret$0 = _ULong___init__impl__c78o9k(this_0);
        builder.s21(tmp$ret$0);
      }
      x1u(decoder, index, builder, checkIndex) {
        return this.p21(decoder, index, builder instanceof ULongArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      d1x(decoder, index, builder, checkIndex) {
        return this.p21(decoder, index, builder instanceof ULongArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      t21(encoder, content, size) {
        var inductionVariable = 0;
        if (inductionVariable < size)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var tmp = encoder.u1s(this.t1w_1, i);
            // Inline function 'kotlin.ULong.toLong' call
            var this_0 = ULongArray__get_impl_pr71q9(content, i);
            var tmp$ret$0 = _ULong___get_data__impl__fggpzb(this_0);
            tmp.e1s(tmp$ret$0);
          }
           while (inductionVariable < size);
      }
      e1x(encoder, content, size) {
        return this.t21(encoder, content instanceof ULongArray() ? content.vu_1 : THROW_CCE(), size);
      }
    }
    initMetadataForObject($, 'ULongArraySerializer', VOID, VOID, [KSerializer()]);
    ULongArraySerializerClass = $;
  }
  return ULongArraySerializerClass;
}
var ULongArraySerializer_instance;
function ULongArraySerializer_getInstance() {
  if (ULongArraySerializer_instance === VOID)
    new (ULongArraySerializer())();
  return ULongArraySerializer_instance;
}
var IntArraySerializerClass;
function IntArraySerializer() {
  if (IntArraySerializerClass === VOID) {
    class $ extends PrimitiveArraySerializer() {
      constructor() {
        IntArraySerializer_instance = null;
        super(serializer_4(IntCompanionObject_instance));
        IntArraySerializer_instance = this;
      }
      w21(_this__u8e3s4) {
        return _this__u8e3s4.length;
      }
      r1v(_this__u8e3s4) {
        return this.w21((!(_this__u8e3s4 == null) ? isIntArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      x21(_this__u8e3s4) {
        return new (IntArrayBuilder())(_this__u8e3s4);
      }
      m1u(_this__u8e3s4) {
        return this.x21((!(_this__u8e3s4 == null) ? isIntArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      c1x() {
        return new Int32Array(0);
      }
      y21(decoder, index, builder, checkIndex) {
        builder.b22(decoder.i1r(this.t1w_1, index));
      }
      x1u(decoder, index, builder, checkIndex) {
        return this.y21(decoder, index, builder instanceof IntArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      d1x(decoder, index, builder, checkIndex) {
        return this.y21(decoder, index, builder instanceof IntArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      c22(encoder, content, size) {
        var inductionVariable = 0;
        if (inductionVariable < size)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            encoder.o1s(this.t1w_1, i, content[i]);
          }
           while (inductionVariable < size);
      }
      e1x(encoder, content, size) {
        return this.c22(encoder, (!(content == null) ? isIntArray(content) : false) ? content : THROW_CCE(), size);
      }
    }
    initMetadataForObject($, 'IntArraySerializer', VOID, VOID, [KSerializer()]);
    IntArraySerializerClass = $;
  }
  return IntArraySerializerClass;
}
var IntArraySerializer_instance;
function IntArraySerializer_getInstance() {
  if (IntArraySerializer_instance === VOID)
    new (IntArraySerializer())();
  return IntArraySerializer_instance;
}
var UIntArraySerializerClass;
function UIntArraySerializer() {
  if (UIntArraySerializerClass === VOID) {
    class $ extends PrimitiveArraySerializer() {
      constructor() {
        UIntArraySerializer_instance = null;
        super(serializer_5(Companion_getInstance_1()));
        UIntArraySerializer_instance = this;
      }
      f22(_this__u8e3s4) {
        return _UIntArray___get_size__impl__r6l8ci(_this__u8e3s4);
      }
      r1v(_this__u8e3s4) {
        return this.f22(_this__u8e3s4 instanceof UIntArray() ? _this__u8e3s4.ju_1 : THROW_CCE());
      }
      g22(_this__u8e3s4) {
        return new (UIntArrayBuilder())(_this__u8e3s4);
      }
      m1u(_this__u8e3s4) {
        return this.g22(_this__u8e3s4 instanceof UIntArray() ? _this__u8e3s4.ju_1 : THROW_CCE());
      }
      h22() {
        return _UIntArray___init__impl__ghjpc6(0);
      }
      c1x() {
        return new (UIntArray())(this.h22());
      }
      i22(decoder, index, builder, checkIndex) {
        // Inline function 'kotlin.toUInt' call
        var this_0 = decoder.o1r(this.t1w_1, index).t1q();
        var tmp$ret$0 = _UInt___init__impl__l7qpdl(this_0);
        builder.l22(tmp$ret$0);
      }
      x1u(decoder, index, builder, checkIndex) {
        return this.i22(decoder, index, builder instanceof UIntArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      d1x(decoder, index, builder, checkIndex) {
        return this.i22(decoder, index, builder instanceof UIntArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      m22(encoder, content, size) {
        var inductionVariable = 0;
        if (inductionVariable < size)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var tmp = encoder.u1s(this.t1w_1, i);
            // Inline function 'kotlin.UInt.toInt' call
            var this_0 = UIntArray__get_impl_gp5kza(content, i);
            var tmp$ret$0 = _UInt___get_data__impl__f0vqqw(this_0);
            tmp.d1s(tmp$ret$0);
          }
           while (inductionVariable < size);
      }
      e1x(encoder, content, size) {
        return this.m22(encoder, content instanceof UIntArray() ? content.ju_1 : THROW_CCE(), size);
      }
    }
    initMetadataForObject($, 'UIntArraySerializer', VOID, VOID, [KSerializer()]);
    UIntArraySerializerClass = $;
  }
  return UIntArraySerializerClass;
}
var UIntArraySerializer_instance;
function UIntArraySerializer_getInstance() {
  if (UIntArraySerializer_instance === VOID)
    new (UIntArraySerializer())();
  return UIntArraySerializer_instance;
}
var ShortArraySerializerClass;
function ShortArraySerializer() {
  if (ShortArraySerializerClass === VOID) {
    class $ extends PrimitiveArraySerializer() {
      constructor() {
        ShortArraySerializer_instance = null;
        super(serializer_6(ShortCompanionObject_instance));
        ShortArraySerializer_instance = this;
      }
      p22(_this__u8e3s4) {
        return _this__u8e3s4.length;
      }
      r1v(_this__u8e3s4) {
        return this.p22((!(_this__u8e3s4 == null) ? isShortArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      q22(_this__u8e3s4) {
        return new (ShortArrayBuilder())(_this__u8e3s4);
      }
      m1u(_this__u8e3s4) {
        return this.q22((!(_this__u8e3s4 == null) ? isShortArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      c1x() {
        return new Int16Array(0);
      }
      r22(decoder, index, builder, checkIndex) {
        builder.u22(decoder.h1r(this.t1w_1, index));
      }
      x1u(decoder, index, builder, checkIndex) {
        return this.r22(decoder, index, builder instanceof ShortArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      d1x(decoder, index, builder, checkIndex) {
        return this.r22(decoder, index, builder instanceof ShortArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      v22(encoder, content, size) {
        var inductionVariable = 0;
        if (inductionVariable < size)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            encoder.n1s(this.t1w_1, i, content[i]);
          }
           while (inductionVariable < size);
      }
      e1x(encoder, content, size) {
        return this.v22(encoder, (!(content == null) ? isShortArray(content) : false) ? content : THROW_CCE(), size);
      }
    }
    initMetadataForObject($, 'ShortArraySerializer', VOID, VOID, [KSerializer()]);
    ShortArraySerializerClass = $;
  }
  return ShortArraySerializerClass;
}
var ShortArraySerializer_instance;
function ShortArraySerializer_getInstance() {
  if (ShortArraySerializer_instance === VOID)
    new (ShortArraySerializer())();
  return ShortArraySerializer_instance;
}
var UShortArraySerializerClass;
function UShortArraySerializer() {
  if (UShortArraySerializerClass === VOID) {
    class $ extends PrimitiveArraySerializer() {
      constructor() {
        UShortArraySerializer_instance = null;
        super(serializer_7(Companion_getInstance_2()));
        UShortArraySerializer_instance = this;
      }
      y22(_this__u8e3s4) {
        return _UShortArray___get_size__impl__jqto1b(_this__u8e3s4);
      }
      r1v(_this__u8e3s4) {
        return this.y22(_this__u8e3s4 instanceof UShortArray() ? _this__u8e3s4.hv_1 : THROW_CCE());
      }
      z22(_this__u8e3s4) {
        return new (UShortArrayBuilder())(_this__u8e3s4);
      }
      m1u(_this__u8e3s4) {
        return this.z22(_this__u8e3s4 instanceof UShortArray() ? _this__u8e3s4.hv_1 : THROW_CCE());
      }
      a23() {
        return _UShortArray___init__impl__9b26ef(0);
      }
      c1x() {
        return new (UShortArray())(this.a23());
      }
      b23(decoder, index, builder, checkIndex) {
        // Inline function 'kotlin.toUShort' call
        var this_0 = decoder.o1r(this.t1w_1, index).s1q();
        var tmp$ret$0 = _UShort___init__impl__jigrne(this_0);
        builder.e23(tmp$ret$0);
      }
      x1u(decoder, index, builder, checkIndex) {
        return this.b23(decoder, index, builder instanceof UShortArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      d1x(decoder, index, builder, checkIndex) {
        return this.b23(decoder, index, builder instanceof UShortArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      f23(encoder, content, size) {
        var inductionVariable = 0;
        if (inductionVariable < size)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var tmp = encoder.u1s(this.t1w_1, i);
            // Inline function 'kotlin.UShort.toShort' call
            var this_0 = UShortArray__get_impl_fnbhmx(content, i);
            var tmp$ret$0 = _UShort___get_data__impl__g0245(this_0);
            tmp.c1s(tmp$ret$0);
          }
           while (inductionVariable < size);
      }
      e1x(encoder, content, size) {
        return this.f23(encoder, content instanceof UShortArray() ? content.hv_1 : THROW_CCE(), size);
      }
    }
    initMetadataForObject($, 'UShortArraySerializer', VOID, VOID, [KSerializer()]);
    UShortArraySerializerClass = $;
  }
  return UShortArraySerializerClass;
}
var UShortArraySerializer_instance;
function UShortArraySerializer_getInstance() {
  if (UShortArraySerializer_instance === VOID)
    new (UShortArraySerializer())();
  return UShortArraySerializer_instance;
}
var ByteArraySerializerClass;
function ByteArraySerializer() {
  if (ByteArraySerializerClass === VOID) {
    class $ extends PrimitiveArraySerializer() {
      constructor() {
        ByteArraySerializer_instance = null;
        super(serializer_8(ByteCompanionObject_instance));
        ByteArraySerializer_instance = this;
      }
      i23(_this__u8e3s4) {
        return _this__u8e3s4.length;
      }
      r1v(_this__u8e3s4) {
        return this.i23((!(_this__u8e3s4 == null) ? isByteArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      j23(_this__u8e3s4) {
        return new (ByteArrayBuilder())(_this__u8e3s4);
      }
      m1u(_this__u8e3s4) {
        return this.j23((!(_this__u8e3s4 == null) ? isByteArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      c1x() {
        return new Int8Array(0);
      }
      k23(decoder, index, builder, checkIndex) {
        builder.n23(decoder.g1r(this.t1w_1, index));
      }
      x1u(decoder, index, builder, checkIndex) {
        return this.k23(decoder, index, builder instanceof ByteArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      d1x(decoder, index, builder, checkIndex) {
        return this.k23(decoder, index, builder instanceof ByteArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      o23(encoder, content, size) {
        var inductionVariable = 0;
        if (inductionVariable < size)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            encoder.m1s(this.t1w_1, i, content[i]);
          }
           while (inductionVariable < size);
      }
      e1x(encoder, content, size) {
        return this.o23(encoder, (!(content == null) ? isByteArray(content) : false) ? content : THROW_CCE(), size);
      }
    }
    initMetadataForObject($, 'ByteArraySerializer', VOID, VOID, [KSerializer()]);
    ByteArraySerializerClass = $;
  }
  return ByteArraySerializerClass;
}
var ByteArraySerializer_instance;
function ByteArraySerializer_getInstance() {
  if (ByteArraySerializer_instance === VOID)
    new (ByteArraySerializer())();
  return ByteArraySerializer_instance;
}
var UByteArraySerializerClass;
function UByteArraySerializer() {
  if (UByteArraySerializerClass === VOID) {
    class $ extends PrimitiveArraySerializer() {
      constructor() {
        UByteArraySerializer_instance = null;
        super(serializer_9(Companion_getInstance_3()));
        UByteArraySerializer_instance = this;
      }
      r23(_this__u8e3s4) {
        return _UByteArray___get_size__impl__h6pkdv(_this__u8e3s4);
      }
      r1v(_this__u8e3s4) {
        return this.r23(_this__u8e3s4 instanceof UByteArray() ? _this__u8e3s4.xt_1 : THROW_CCE());
      }
      s23(_this__u8e3s4) {
        return new (UByteArrayBuilder())(_this__u8e3s4);
      }
      m1u(_this__u8e3s4) {
        return this.s23(_this__u8e3s4 instanceof UByteArray() ? _this__u8e3s4.xt_1 : THROW_CCE());
      }
      t23() {
        return _UByteArray___init__impl__ip4y9n(0);
      }
      c1x() {
        return new (UByteArray())(this.t23());
      }
      u23(decoder, index, builder, checkIndex) {
        // Inline function 'kotlin.toUByte' call
        var this_0 = decoder.o1r(this.t1w_1, index).r1q();
        var tmp$ret$0 = _UByte___init__impl__g9hnc4(this_0);
        builder.x23(tmp$ret$0);
      }
      x1u(decoder, index, builder, checkIndex) {
        return this.u23(decoder, index, builder instanceof UByteArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      d1x(decoder, index, builder, checkIndex) {
        return this.u23(decoder, index, builder instanceof UByteArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      y23(encoder, content, size) {
        var inductionVariable = 0;
        if (inductionVariable < size)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var tmp = encoder.u1s(this.t1w_1, i);
            // Inline function 'kotlin.UByte.toByte' call
            var this_0 = UByteArray__get_impl_t5f3hv(content, i);
            var tmp$ret$0 = _UByte___get_data__impl__jof9qr(this_0);
            tmp.b1s(tmp$ret$0);
          }
           while (inductionVariable < size);
      }
      e1x(encoder, content, size) {
        return this.y23(encoder, content instanceof UByteArray() ? content.xt_1 : THROW_CCE(), size);
      }
    }
    initMetadataForObject($, 'UByteArraySerializer', VOID, VOID, [KSerializer()]);
    UByteArraySerializerClass = $;
  }
  return UByteArraySerializerClass;
}
var UByteArraySerializer_instance;
function UByteArraySerializer_getInstance() {
  if (UByteArraySerializer_instance === VOID)
    new (UByteArraySerializer())();
  return UByteArraySerializer_instance;
}
var BooleanArraySerializerClass;
function BooleanArraySerializer() {
  if (BooleanArraySerializerClass === VOID) {
    class $ extends PrimitiveArraySerializer() {
      constructor() {
        BooleanArraySerializer_instance = null;
        super(serializer_10(BooleanCompanionObject_instance));
        BooleanArraySerializer_instance = this;
      }
      b24(_this__u8e3s4) {
        return _this__u8e3s4.length;
      }
      r1v(_this__u8e3s4) {
        return this.b24((!(_this__u8e3s4 == null) ? isBooleanArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      c24(_this__u8e3s4) {
        return new (BooleanArrayBuilder())(_this__u8e3s4);
      }
      m1u(_this__u8e3s4) {
        return this.c24((!(_this__u8e3s4 == null) ? isBooleanArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      c1x() {
        return booleanArray(0);
      }
      d24(decoder, index, builder, checkIndex) {
        builder.g24(decoder.f1r(this.t1w_1, index));
      }
      x1u(decoder, index, builder, checkIndex) {
        return this.d24(decoder, index, builder instanceof BooleanArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      d1x(decoder, index, builder, checkIndex) {
        return this.d24(decoder, index, builder instanceof BooleanArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      h24(encoder, content, size) {
        var inductionVariable = 0;
        if (inductionVariable < size)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            encoder.l1s(this.t1w_1, i, content[i]);
          }
           while (inductionVariable < size);
      }
      e1x(encoder, content, size) {
        return this.h24(encoder, (!(content == null) ? isBooleanArray(content) : false) ? content : THROW_CCE(), size);
      }
    }
    initMetadataForObject($, 'BooleanArraySerializer', VOID, VOID, [KSerializer()]);
    BooleanArraySerializerClass = $;
  }
  return BooleanArraySerializerClass;
}
var BooleanArraySerializer_instance;
function BooleanArraySerializer_getInstance() {
  if (BooleanArraySerializer_instance === VOID)
    new (BooleanArraySerializer())();
  return BooleanArraySerializer_instance;
}
var CharArrayBuilderClass;
function CharArrayBuilder() {
  if (CharArrayBuilderClass === VOID) {
    class $ extends PrimitiveArrayBuilder() {
      constructor(bufferWithData) {
        super();
        this.f20_1 = bufferWithData;
        this.g20_1 = bufferWithData.length;
        this.z1w(10);
      }
      v1w() {
        return this.g20_1;
      }
      z1w(requiredCapacity) {
        if (this.f20_1.length < requiredCapacity)
          this.f20_1 = copyOf(this.f20_1, coerceAtLeast(requiredCapacity, imul(this.f20_1.length, 2)));
      }
      h20(c) {
        this.g1x();
        var tmp = this.f20_1;
        var _unary__edvuaz = this.g20_1;
        this.g20_1 = _unary__edvuaz + 1 | 0;
        tmp[_unary__edvuaz] = c;
      }
      x1w() {
        return copyOf(this.f20_1, this.g20_1);
      }
    }
    initMetadataForClass($, 'CharArrayBuilder');
    CharArrayBuilderClass = $;
  }
  return CharArrayBuilderClass;
}
var DoubleArrayBuilderClass;
function DoubleArrayBuilder() {
  if (DoubleArrayBuilderClass === VOID) {
    class $ extends PrimitiveArrayBuilder() {
      constructor(bufferWithData) {
        super();
        this.o20_1 = bufferWithData;
        this.p20_1 = bufferWithData.length;
        this.z1w(10);
      }
      v1w() {
        return this.p20_1;
      }
      z1w(requiredCapacity) {
        if (this.o20_1.length < requiredCapacity)
          this.o20_1 = copyOf_0(this.o20_1, coerceAtLeast(requiredCapacity, imul(this.o20_1.length, 2)));
      }
      q20(c) {
        this.g1x();
        var tmp = this.o20_1;
        var _unary__edvuaz = this.p20_1;
        this.p20_1 = _unary__edvuaz + 1 | 0;
        tmp[_unary__edvuaz] = c;
      }
      x1w() {
        return copyOf_0(this.o20_1, this.p20_1);
      }
    }
    initMetadataForClass($, 'DoubleArrayBuilder');
    DoubleArrayBuilderClass = $;
  }
  return DoubleArrayBuilderClass;
}
var FloatArrayBuilderClass;
function FloatArrayBuilder() {
  if (FloatArrayBuilderClass === VOID) {
    class $ extends PrimitiveArrayBuilder() {
      constructor(bufferWithData) {
        super();
        this.x20_1 = bufferWithData;
        this.y20_1 = bufferWithData.length;
        this.z1w(10);
      }
      v1w() {
        return this.y20_1;
      }
      z1w(requiredCapacity) {
        if (this.x20_1.length < requiredCapacity)
          this.x20_1 = copyOf_1(this.x20_1, coerceAtLeast(requiredCapacity, imul(this.x20_1.length, 2)));
      }
      z20(c) {
        this.g1x();
        var tmp = this.x20_1;
        var _unary__edvuaz = this.y20_1;
        this.y20_1 = _unary__edvuaz + 1 | 0;
        tmp[_unary__edvuaz] = c;
      }
      x1w() {
        return copyOf_1(this.x20_1, this.y20_1);
      }
    }
    initMetadataForClass($, 'FloatArrayBuilder');
    FloatArrayBuilderClass = $;
  }
  return FloatArrayBuilderClass;
}
var LongArrayBuilderClass;
function LongArrayBuilder() {
  if (LongArrayBuilderClass === VOID) {
    class $ extends PrimitiveArrayBuilder() {
      constructor(bufferWithData) {
        super();
        this.g21_1 = bufferWithData;
        this.h21_1 = bufferWithData.length;
        this.z1w(10);
      }
      v1w() {
        return this.h21_1;
      }
      z1w(requiredCapacity) {
        if (this.g21_1.length < requiredCapacity)
          this.g21_1 = copyOf_2(this.g21_1, coerceAtLeast(requiredCapacity, imul(this.g21_1.length, 2)));
      }
      i21(c) {
        this.g1x();
        var tmp = this.g21_1;
        var _unary__edvuaz = this.h21_1;
        this.h21_1 = _unary__edvuaz + 1 | 0;
        tmp[_unary__edvuaz] = c;
      }
      x1w() {
        return copyOf_2(this.g21_1, this.h21_1);
      }
    }
    initMetadataForClass($, 'LongArrayBuilder');
    LongArrayBuilderClass = $;
  }
  return LongArrayBuilderClass;
}
var ULongArrayBuilderClass;
function ULongArrayBuilder() {
  if (ULongArrayBuilderClass === VOID) {
    class $ extends PrimitiveArrayBuilder() {
      constructor(bufferWithData) {
        super();
        this.q21_1 = bufferWithData;
        this.r21_1 = _ULongArray___get_size__impl__ju6dtr(bufferWithData);
        this.z1w(10);
      }
      v1w() {
        return this.r21_1;
      }
      z1w(requiredCapacity) {
        if (_ULongArray___get_size__impl__ju6dtr(this.q21_1) < requiredCapacity) {
          var tmp = this;
          var tmp0 = this.q21_1;
          // Inline function 'kotlin.collections.copyOf' call
          var newSize = coerceAtLeast(requiredCapacity, imul(_ULongArray___get_size__impl__ju6dtr(this.q21_1), 2));
          tmp.q21_1 = _ULongArray___init__impl__twm1l3_0(copyOf_2(_ULongArray___get_storage__impl__28e64j(tmp0), newSize));
        }
      }
      s21(c) {
        this.g1x();
        var tmp = this.q21_1;
        var _unary__edvuaz = this.r21_1;
        this.r21_1 = _unary__edvuaz + 1 | 0;
        ULongArray__set_impl_z19mvh(tmp, _unary__edvuaz, c);
      }
      i24() {
        var tmp0 = this.q21_1;
        // Inline function 'kotlin.collections.copyOf' call
        var newSize = this.r21_1;
        return _ULongArray___init__impl__twm1l3_0(copyOf_2(_ULongArray___get_storage__impl__28e64j(tmp0), newSize));
      }
      x1w() {
        return new (ULongArray())(this.i24());
      }
    }
    initMetadataForClass($, 'ULongArrayBuilder');
    ULongArrayBuilderClass = $;
  }
  return ULongArrayBuilderClass;
}
var IntArrayBuilderClass;
function IntArrayBuilder() {
  if (IntArrayBuilderClass === VOID) {
    class $ extends PrimitiveArrayBuilder() {
      constructor(bufferWithData) {
        super();
        this.z21_1 = bufferWithData;
        this.a22_1 = bufferWithData.length;
        this.z1w(10);
      }
      v1w() {
        return this.a22_1;
      }
      z1w(requiredCapacity) {
        if (this.z21_1.length < requiredCapacity)
          this.z21_1 = copyOf_3(this.z21_1, coerceAtLeast(requiredCapacity, imul(this.z21_1.length, 2)));
      }
      b22(c) {
        this.g1x();
        var tmp = this.z21_1;
        var _unary__edvuaz = this.a22_1;
        this.a22_1 = _unary__edvuaz + 1 | 0;
        tmp[_unary__edvuaz] = c;
      }
      x1w() {
        return copyOf_3(this.z21_1, this.a22_1);
      }
    }
    initMetadataForClass($, 'IntArrayBuilder');
    IntArrayBuilderClass = $;
  }
  return IntArrayBuilderClass;
}
var UIntArrayBuilderClass;
function UIntArrayBuilder() {
  if (UIntArrayBuilderClass === VOID) {
    class $ extends PrimitiveArrayBuilder() {
      constructor(bufferWithData) {
        super();
        this.j22_1 = bufferWithData;
        this.k22_1 = _UIntArray___get_size__impl__r6l8ci(bufferWithData);
        this.z1w(10);
      }
      v1w() {
        return this.k22_1;
      }
      z1w(requiredCapacity) {
        if (_UIntArray___get_size__impl__r6l8ci(this.j22_1) < requiredCapacity) {
          var tmp = this;
          var tmp0 = this.j22_1;
          // Inline function 'kotlin.collections.copyOf' call
          var newSize = coerceAtLeast(requiredCapacity, imul(_UIntArray___get_size__impl__r6l8ci(this.j22_1), 2));
          tmp.j22_1 = _UIntArray___init__impl__ghjpc6_0(copyOf_3(_UIntArray___get_storage__impl__92a0v0(tmp0), newSize));
        }
      }
      l22(c) {
        this.g1x();
        var tmp = this.j22_1;
        var _unary__edvuaz = this.k22_1;
        this.k22_1 = _unary__edvuaz + 1 | 0;
        UIntArray__set_impl_7f2zu2(tmp, _unary__edvuaz, c);
      }
      j24() {
        var tmp0 = this.j22_1;
        // Inline function 'kotlin.collections.copyOf' call
        var newSize = this.k22_1;
        return _UIntArray___init__impl__ghjpc6_0(copyOf_3(_UIntArray___get_storage__impl__92a0v0(tmp0), newSize));
      }
      x1w() {
        return new (UIntArray())(this.j24());
      }
    }
    initMetadataForClass($, 'UIntArrayBuilder');
    UIntArrayBuilderClass = $;
  }
  return UIntArrayBuilderClass;
}
var ShortArrayBuilderClass;
function ShortArrayBuilder() {
  if (ShortArrayBuilderClass === VOID) {
    class $ extends PrimitiveArrayBuilder() {
      constructor(bufferWithData) {
        super();
        this.s22_1 = bufferWithData;
        this.t22_1 = bufferWithData.length;
        this.z1w(10);
      }
      v1w() {
        return this.t22_1;
      }
      z1w(requiredCapacity) {
        if (this.s22_1.length < requiredCapacity)
          this.s22_1 = copyOf_4(this.s22_1, coerceAtLeast(requiredCapacity, imul(this.s22_1.length, 2)));
      }
      u22(c) {
        this.g1x();
        var tmp = this.s22_1;
        var _unary__edvuaz = this.t22_1;
        this.t22_1 = _unary__edvuaz + 1 | 0;
        tmp[_unary__edvuaz] = c;
      }
      x1w() {
        return copyOf_4(this.s22_1, this.t22_1);
      }
    }
    initMetadataForClass($, 'ShortArrayBuilder');
    ShortArrayBuilderClass = $;
  }
  return ShortArrayBuilderClass;
}
var UShortArrayBuilderClass;
function UShortArrayBuilder() {
  if (UShortArrayBuilderClass === VOID) {
    class $ extends PrimitiveArrayBuilder() {
      constructor(bufferWithData) {
        super();
        this.c23_1 = bufferWithData;
        this.d23_1 = _UShortArray___get_size__impl__jqto1b(bufferWithData);
        this.z1w(10);
      }
      v1w() {
        return this.d23_1;
      }
      z1w(requiredCapacity) {
        if (_UShortArray___get_size__impl__jqto1b(this.c23_1) < requiredCapacity) {
          var tmp = this;
          var tmp0 = this.c23_1;
          // Inline function 'kotlin.collections.copyOf' call
          var newSize = coerceAtLeast(requiredCapacity, imul(_UShortArray___get_size__impl__jqto1b(this.c23_1), 2));
          tmp.c23_1 = _UShortArray___init__impl__9b26ef_0(copyOf_4(_UShortArray___get_storage__impl__t2jpv5(tmp0), newSize));
        }
      }
      e23(c) {
        this.g1x();
        var tmp = this.c23_1;
        var _unary__edvuaz = this.d23_1;
        this.d23_1 = _unary__edvuaz + 1 | 0;
        UShortArray__set_impl_6d8whp(tmp, _unary__edvuaz, c);
      }
      k24() {
        var tmp0 = this.c23_1;
        // Inline function 'kotlin.collections.copyOf' call
        var newSize = this.d23_1;
        return _UShortArray___init__impl__9b26ef_0(copyOf_4(_UShortArray___get_storage__impl__t2jpv5(tmp0), newSize));
      }
      x1w() {
        return new (UShortArray())(this.k24());
      }
    }
    initMetadataForClass($, 'UShortArrayBuilder');
    UShortArrayBuilderClass = $;
  }
  return UShortArrayBuilderClass;
}
var ByteArrayBuilderClass;
function ByteArrayBuilder() {
  if (ByteArrayBuilderClass === VOID) {
    class $ extends PrimitiveArrayBuilder() {
      constructor(bufferWithData) {
        super();
        this.l23_1 = bufferWithData;
        this.m23_1 = bufferWithData.length;
        this.z1w(10);
      }
      v1w() {
        return this.m23_1;
      }
      z1w(requiredCapacity) {
        if (this.l23_1.length < requiredCapacity)
          this.l23_1 = copyOf_5(this.l23_1, coerceAtLeast(requiredCapacity, imul(this.l23_1.length, 2)));
      }
      n23(c) {
        this.g1x();
        var tmp = this.l23_1;
        var _unary__edvuaz = this.m23_1;
        this.m23_1 = _unary__edvuaz + 1 | 0;
        tmp[_unary__edvuaz] = c;
      }
      x1w() {
        return copyOf_5(this.l23_1, this.m23_1);
      }
    }
    initMetadataForClass($, 'ByteArrayBuilder');
    ByteArrayBuilderClass = $;
  }
  return ByteArrayBuilderClass;
}
var UByteArrayBuilderClass;
function UByteArrayBuilder() {
  if (UByteArrayBuilderClass === VOID) {
    class $ extends PrimitiveArrayBuilder() {
      constructor(bufferWithData) {
        super();
        this.v23_1 = bufferWithData;
        this.w23_1 = _UByteArray___get_size__impl__h6pkdv(bufferWithData);
        this.z1w(10);
      }
      v1w() {
        return this.w23_1;
      }
      z1w(requiredCapacity) {
        if (_UByteArray___get_size__impl__h6pkdv(this.v23_1) < requiredCapacity) {
          var tmp = this;
          var tmp0 = this.v23_1;
          // Inline function 'kotlin.collections.copyOf' call
          var newSize = coerceAtLeast(requiredCapacity, imul(_UByteArray___get_size__impl__h6pkdv(this.v23_1), 2));
          tmp.v23_1 = _UByteArray___init__impl__ip4y9n_0(copyOf_5(_UByteArray___get_storage__impl__d4kctt(tmp0), newSize));
        }
      }
      x23(c) {
        this.g1x();
        var tmp = this.v23_1;
        var _unary__edvuaz = this.w23_1;
        this.w23_1 = _unary__edvuaz + 1 | 0;
        UByteArray__set_impl_jvcicn(tmp, _unary__edvuaz, c);
      }
      l24() {
        var tmp0 = this.v23_1;
        // Inline function 'kotlin.collections.copyOf' call
        var newSize = this.w23_1;
        return _UByteArray___init__impl__ip4y9n_0(copyOf_5(_UByteArray___get_storage__impl__d4kctt(tmp0), newSize));
      }
      x1w() {
        return new (UByteArray())(this.l24());
      }
    }
    initMetadataForClass($, 'UByteArrayBuilder');
    UByteArrayBuilderClass = $;
  }
  return UByteArrayBuilderClass;
}
var BooleanArrayBuilderClass;
function BooleanArrayBuilder() {
  if (BooleanArrayBuilderClass === VOID) {
    class $ extends PrimitiveArrayBuilder() {
      constructor(bufferWithData) {
        super();
        this.e24_1 = bufferWithData;
        this.f24_1 = bufferWithData.length;
        this.z1w(10);
      }
      v1w() {
        return this.f24_1;
      }
      z1w(requiredCapacity) {
        if (this.e24_1.length < requiredCapacity)
          this.e24_1 = copyOf_6(this.e24_1, coerceAtLeast(requiredCapacity, imul(this.e24_1.length, 2)));
      }
      g24(c) {
        this.g1x();
        var tmp = this.e24_1;
        var _unary__edvuaz = this.f24_1;
        this.f24_1 = _unary__edvuaz + 1 | 0;
        tmp[_unary__edvuaz] = c;
      }
      x1w() {
        return copyOf_6(this.e24_1, this.f24_1);
      }
    }
    initMetadataForClass($, 'BooleanArrayBuilder');
    BooleanArrayBuilderClass = $;
  }
  return BooleanArrayBuilderClass;
}
//region block: exports
export {
  BooleanArraySerializer_getInstance as BooleanArraySerializer_getInstance2n8qc5t6bzidf,
  ByteArraySerializer_getInstance as ByteArraySerializer_getInstance2b3lr11f78vwx,
  CharArraySerializer_getInstance as CharArraySerializer_getInstance349ncb5rlo1ht,
  DoubleArraySerializer_getInstance as DoubleArraySerializer_getInstance3a4lrva1sxxow,
  FloatArraySerializer_getInstance as FloatArraySerializer_getInstance3k2m7svdlnx7s,
  IntArraySerializer_getInstance as IntArraySerializer_getInstance1rr9hqd2i2l73,
  LongArraySerializer_getInstance as LongArraySerializer_getInstancem8l8n7vn8fdi,
  ShortArraySerializer_getInstance as ShortArraySerializer_getInstance29h5bb80p5isf,
  UByteArraySerializer_getInstance as UByteArraySerializer_getInstance30v15h7pvdc1u,
  UIntArraySerializer_getInstance as UIntArraySerializer_getInstance34p5jz9nln6hn,
  ULongArraySerializer_getInstance as ULongArraySerializer_getInstance1sitphir7efjg,
  UShortArraySerializer_getInstance as UShortArraySerializer_getInstance2ie8r4hvo8wlh,
};
//endregion

//# sourceMappingURL=PrimitiveArraysSerializers.mjs.map
